/**
 * Annual order volume at or above which returns onboarding routes to a
 * human-assisted handoff instead of self-serve go-live.
 */
export const RETURNS_LARGE_MERCHANT_THRESHOLD = 18_000;

/** `form_data` key under which the persisted routing decision is stored. */
export const RETURNS_ROUTING_DECISION_STEP_ID = "routing-decision";

export interface ReturnsRoutingClassification {
  decision: "call" | "self-serve";
  reason:
    | "volume-at-or-above-threshold"
    | "volume-below-threshold"
    | "volume-unavailable-after-polling";
}

/**
 * Routes on total (not just US-web) volume so merchants large in any dimension
 * get a human handoff; null volume (data-pull pending/failed) also routes to call.
 */
export function classifyReturnsRouting(
  totalAnnualOrderVolume: number | null,
): ReturnsRoutingClassification {
  if (totalAnnualOrderVolume == null) {
    return { decision: "call", reason: "volume-unavailable-after-polling" };
  }
  if (totalAnnualOrderVolume >= RETURNS_LARGE_MERCHANT_THRESHOLD) {
    return { decision: "call", reason: "volume-at-or-above-threshold" };
  }
  return { decision: "self-serve", reason: "volume-below-threshold" };
}
